<template>
    <div class="page-container">
        <Header></Header>
        <div class="content" style="max-width: 800px">
            <div class="img-container">
                <img src="../assets/comic_photo.jpg">
            </div>
            <div class="my-bio">
                <p>Hi my name is Martin. I'm an internet computing student at University Passau.
                    My passion is creative web development and I enjoy to learn new things.</p>
            </div>
            <div class="short-resume">
                <p>watch time pass by</p>
            </div>
            <div>
                <b-carousel
                        id="carousel-1"
                        v-model="slide"
                        :interval="6000"
                        controls
                        indicators
                        img-width="1024"
                        img-height="480"
                        style="text-shadow: 1px 1px 2px #333;"
                        @sliding-start="onSlideStart"
                        @sliding-end="onSlideEnd">

                    <b-carousel-slide caption="" :img-src=srcOne>
                    </b-carousel-slide>

                    <b-carousel-slide caption="" :img-src=srcTwo>
                    </b-carousel-slide>

                    <b-carousel-slide caption="" :img-src=srcThree>
                    </b-carousel-slide>

                    <b-carousel-slide caption="" :img-src=srcFour>
                    </b-carousel-slide>

                </b-carousel>
            </div>
            <div style="height: 20px"></div>
            <div class="personal-words" style="margin-top: 30px">
                <h1>some personal words</h1>
                <p>Nach über 6 Jahren als Bankangestellter war der Schritt aus der Arbeitswelt heraus, an die Universität, ein großer.
                    Raus aus dem Alltag. Verzicht auf sehr viele Konsumgüter. Und nach langer Zeit wieder Vollzeit lernen.
                    Rückwirkend kann ich darüber glücklich sein, diese Entscheidung so getroffen zu haben. Neben der neuen Lebenserfahrung
                    konnte ich eine neue Passion entdecken. Die Webentwicklung.
                    <br/> <br/>
                    Falls Sie ein Projekt planen, Fragen oder Anregungen bezüglich dieser Website haben oder einfach
                    nur Hallo sagen wollen, können Sie gerne mit mir in Kontakt treten.
                </p>
            </div>
            <div style="height: 60px"></div>

            <b-button to="/contact" pill variant="warning" style="color: black; font-family: 'Mansalva', cursive;">
                <b-icon icon="cursor-fill" style="margin-right: 5px"></b-icon>
                message me</b-button>
            <div style="height: 50px"></div>
        </div>
        <Footer></Footer>
    </div>

</template>

<script>

    import Header from "@/components/Header";
    import Footer from "@/components/Footer";

    export default {
        name: "AboutPage",
        components: {Footer, Header},
        component: {Header, Footer},
        data() {
            return {
                slide: 0,
                sliding: null,
                srcOne: require('@/assets/azubi_background.jpg'),
                srcTwo: require('@/assets/berater_background.jpg'),
                srcThree: require('@/assets/fachwirt_background.jpg'),
                srcFour: require('@/assets/university_background.jpg')

            }
        },
        methods: {
            onSlideStart() {
                this.sliding = true
            },
            onSlideEnd() {
                this.sliding = false
            }
        },
        mounted () {
            window.scrollTo(0, 0)
        }
    }
</script>

<style scoped>

    .page-container {
        background: linear-gradient(to left, black, #202020);
    }

    .content {
        width: 100vw;
        max-width: 1100px;
        margin-right: auto;
        margin-left: auto;
        height: auto;
        min-height: 200px;
        margin-bottom: 25px;
        position: relative;
        z-index: 20;
        border-radius: 10px;
    }

    .img-container {
        width: 100%;
        height: 30vh;
        position: relative;
    }

    img {
        position: absolute;
        margin: auto;
        height: auto;
        width: 25vh;
        border-radius: 50%;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
    }

    .my-bio {
        height: auto;
    }

    .my-bio p {
        font-size: 1.5rem;
        font-family: 'Roboto', sans-serif;
        color: white;
        letter-spacing: 0.5px;
        text-align: left;
        margin-left: 5vw;
        margin-right: 5vw;
    }

    .short-resume {
        height: auto;
        position: relative;
        margin-bottom: 20px;
    }

    .short-resume p {
        font-size: 3rem;
        font-family: 'Mansalva', cursive;
        text-align: center;
        color: white;
        letter-spacing: 4px;
        margin-top: 70px;
    }

    .personal-words h1{
        color: #FFD700;
        font-family: 'Mansalva', cursive;
        font-size: 3rem;
        letter-spacing: 2px;
        margin-bottom: 40px;
    }

    .personal-words p {
        color: white;
        font-family: 'Roboto', sans-serif;
        font-size: 1.5rem;
        letter-spacing: 2px;
        margin-left: 10px;
        margin-right: 10px;
        text-align: left;
    }

    @media only screen and (max-width: 400px) {

        .content {
            min-height: 200px;
        }

        .my-bio p {
            font-size: 1rem;
        }

        .short-resume p {
            font-size: 1.5rem;
        }

        .short-resume {
            margin-bottom: 0;
        }

        .personal-words h1 {
            font-size: 1.6rem;
        }

        .personal-words p {
            font-size: 1rem;
            text-align: left;
            margin-left: 5vw;
            margin-right: 5vw;
        }

    }

    @media only screen and (min-width: 401px) and (max-width: 700px) {

        .my-bio p {
            font-size: 1rem;
        }

        .short-resume p {
            font-size: 1.5rem;
        }

        .short-resume {
            margin-bottom: 0;
        }

        .personal-words h1 {
            font-size: 1.8rem;
        }

        .personal-words p {
            font-size: 1rem;
            text-align: left;
            margin-left: 5vw;
            margin-right: 5vw;
        }
    }

</style>
